<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19MlOF8/tc-custom/9780814760888.jpg?1719926998781" alt="This image is the cover for the book Brown Boys and Rice Queens, Sexual Cultures"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Brown Boys and Rice Queens, Sexual Cultures
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Honorable Mention for the 2015 Cultural Studies Best Book presented by the Association of Asian American Studies</b><br/><br/><br/><b>Winner of the 2013 CLAGS Fellowship Award for Best First Book Project in LGBT Studies</b><br/><br/><br/><br/><br/><br/>A transnational study of Asian performance shaped by the homoerotics of orientalism, Brown Boys and Rice Queens focuses on the relationship between the white man and the native boy. Eng-Beng Lim unpacks this as the central trope for understanding colonial and cultural encounters in 20th and 21st century Asia and its diaspora. Using the native boy as a critical guide, Lim formulates alternative readings of a traditional Balinese ritual, postcolonial Anglophone theatre in Singapore, and performance art in Asian America.<br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>Tracing the transnational formation of the native boy as racial fetish object across the last century, Lim follows this figure as he is passed from the hands of the colonial empire to the postcolonial nation-state to neoliberal globalization. Read through such figurations, the traffic in native boys among white men serves as an allegory of an infantilized and emasculated Asia, subordinate before colonial whiteness and modernity. Pushing further, Lim addresses the critical paradox of this entrenched relationship that resides even within queer theory itself by formulating critical interventions around “Asian performance.”</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Eng-Beng Lim
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?09365f08